module.exports = __webpack_public_path__ + "static/media/img2.3c9818ce.jpg";